import React, { useRef, useState, useEffect } from "react";
import StyledAuxiliaryMenu from "./styles";

const AuxiliaryMenuContainer = ({ open, children, velo = true }) => {
  const [veloState, setVeloState] = useState({
    superior: false,
    inferior: true,
  });

  const containerRef = useRef(null);
  const scrollRef = useRef(null);

  const onScrollHandler = (e) => {
    const { height } = containerRef.current.getBoundingClientRect();
    const scroll = e.target.getBoundingClientRect();
    const isOnBottom = Math.abs(
      Math.round(scroll.height - height + e.target.scrollTop)
    );

    const isOnTop = e.target.scrollTop;
    if (isOnTop === 0) {
      setVeloState((p) => ({ ...p, superior: false }));
    } else {
      setVeloState((p) => ({ ...p, superior: true }));
    }

    if (isOnBottom === 0) {
      setVeloState((p) => ({ ...p, inferior: false }));
    } else {
      setVeloState((p) => ({ ...p, inferior: true }));
    }
  };

  return (
    <StyledAuxiliaryMenu>
      <div className={`auxiliary-menu ${open ? "auxiliary-menu--open" : ""}`}>
        {velo && veloState.superior && (
          <div className="auxiliary-menu-velo auxiliary-menu-velo--superior" />
        )}

        <div
          className="auxiliary-menu-container"
          onScroll={onScrollHandler}
          ref={scrollRef}
        >
          <div ref={containerRef}>{children}</div>
        </div>

        {velo && veloState.inferior && (
          <div className="auxiliary-menu-velo auxiliary-menu-velo--inferior" />
        )}
      </div>
    </StyledAuxiliaryMenu>
  );
};

export default AuxiliaryMenuContainer;
